import {useQuery} from "@tanstack/react-query";
import {GetCompetitionInfoResponse, GuildsApi} from "@devour/client";

async function getCompetitionInfo(forceEmptyResponse = false): Promise<GetCompetitionInfoResponse> {
    if (forceEmptyResponse) {
        return {
            currentCompetition: null,
            lastCompetition: null,
        } as GetCompetitionInfoResponse;
    }
    return await new GuildsApi().getCompetitionInfo({});
}

function getCompetitionInfoQuery(forceEmptyResponse = false) {
    return {
        queryKey: [
            "getCompetitionInfo",
            forceEmptyResponse,
        ],
        queryFn: () => getCompetitionInfo(forceEmptyResponse),
        keepPreviousData: true,
        staleTime: 30 * 60000,
        refetchOnWindowFocus: false,
        enabled: true,
    } as const;
}

export function useGetCompetitionInfo(forceEmptyResponse = false) {
    // const queryClient = useQueryClient();
    return useQuery(getCompetitionInfoQuery(forceEmptyResponse));
}

